import { GetUtilTransportLocationModel } from "@factory/model/query-model-util-transport-location";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { utilTransportLocationFormDefault } from "./form.default";
import { UtilTransportLocationFormSchema } from "./form.rule";

export const useFormDefaultUtilTransportLocation = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetUtilTransportLocationModel | undefined) => {
    return !cachedValue
      ? utilTransportLocationFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as UtilTransportLocationFormSchema);
  };

  return {
    getDefault,
  };
};
